export default __webpack_public_path__ + "static/media/Group10031.c6413c37.svg";